import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import AgyleButton from '../../../../../components/ui/buttons/agyleButton';
import AddIcon from '@mui/icons-material/Add';
import MedicationNoteTemplateModal from './medicationNoteTemplateModal';
import useOpenState from '../../../../../hooks/useOpenState';
import AgyleTextField from '../../../../../components/ui/fields/agyleTextField';
import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
    },
    button: {
        marginLeft: 'auto',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
}));

const MedicationNoteInput = ({ type, title, value, onChange, disabled = false }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const [isTemplateOpen, openTemplate, closeTemplate] = useOpenState(false, false);

    const [note, setNote] = useState(value || '');

    useEffect(() => {
        setNote(value || '');
    }, [value]);

    useEffect(() => {
        if (onChange) {
            onChange(note);
        }
    }, [note]);

    return (
        <Grid item xs={12} sm={6} className={classes.root}>
            {/*<Box className={classes.root}>*/}
                <div className={classes.divRow}>
                    <Typography fontSize={16} fontWeight={500}>
                        {t(title)}
                    </Typography>

                    <AgyleButton
                        startIcon={<AddIcon />}
                        variant="text"
                        className={classes.button}
                        onClick={openTemplate}
                        style={{ marginBottom: 5 }}
                        disabled={disabled}
                    >
                        {t('template')}
                    </AgyleButton>
                </div>

                <AgyleTextField
                    fullWidth
                    size="small"
                    noBorder={false}
                    withNewBackground
                    placeholder="Note"
                    disabled={disabled}
                    multiline
                    rows={3}
                    value={note}
                    onChange={(e) => {
                        setNote(e.target.value);
                    }}
                />
            {/*</Box>*/}

            {!disabled && (
                <MedicationNoteTemplateModal
                    open={isTemplateOpen}
                    onClose={closeTemplate}
                    type={type}
                    onSelect={(noteObj) => {
                        setNote(noteObj.note);
                    }}
                />
            )}
        </Grid>
    );
};

export default MedicationNoteInput;
